import dayjs from '@root/vendor/dayjs';

export default class Dates {
  static formats = {
    USER_SHORT_NO_YEAR: 'MMM DD',
  };

  static daysAfter(date, days) {
    return dayjs(date).add(days, 'days');
  }

  static monthsAfter(date, months) {
    return dayjs(date).add(months, 'months');
  }

  static formatForUserNoYear(date) {
    return dayjs(date).format(Dates.formats.USER_SHORT_NO_YEAR);
  }

  static whitespaceFormats = {
    DEFAULT: ' ',
    NON_BREAKING_SPACE: '\xa0',
  }
}
